module.exports = __webpack_public_path__ + "static/img/celoscope-26.3c3c3d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-26.jpg
// module id = EvgQ
// module chunks = 51